import { useMemo } from 'react';
import { useCachedQuery } from '../../hooks/useCachedQuery';

// Uma única busca da lista geral do calendário, filtrada no cliente pelo
// dentistId que o AppointmentToCalendarDTO já traz — mesma estratégia do filtro
// de sala (useRoomFilter). Assim trocar de profissional não dispara uma nova
// requisição nem invalida o cache offline, que passa a ter uma entrada só.
export function useCalendarAppointments(dentistId) {
  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery('/appointments');

  const appointments = useMemo(() => {
    const allAppointments = data ?? [];
    return dentistId
      ? allAppointments.filter((appointment) => String(appointment.dentistId) === String(dentistId))
      : allAppointments;
  }, [data, dentistId]);

  return {
    appointments,
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
